const VariantColorsList = {
  carbon: 'carbon',
  blue: 'blue',
  slate: 'slate',
  watermelon: 'watermelon',
  mist: 'mist',
  aloe: 'aloe',
  turquoise: 'turquoise',
  marigold: 'marigold',
  clay: 'clay',
  brandPrimary: 'brandPrimary'
};

export { VariantColorsList };
